import angular from 'angular';

angular.module('AaApp.Opp').constant('fuelTypes', {
    diesel: 1058,
    gas: 1059,
    phev: 1152,
    electric: 1167,
    cng: 1209
});
